import React from 'react';
import styles from './Panel.module.scss';
import classNames from 'classnames';

export default function Panel({ children, className = '' }) {
  return <div className={classNames(styles.root, className)}>{children}</div>;
}
